/* eslint-disable no-unused-vars */
import { Box } from "@chakra-ui/react";
import { useContext, useEffect, useMemo, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AuthContext } from "../../Context/AuthProvider";
import AboutSection from "./AboutUsSection";
import HeroSection from "./HeroSection";

const MySwal = withReactContent(Swal);

const Home = () => {
  const { isLoading, userData, handleLogin } = useContext(AuthContext);
  const [clientPrinciple, setClientPrinciple] = useState(null);

  useEffect(() => {
    const fetchClientPrinciple = async () => {
      try {
        const response = await fetch("/.auth/me");
        const data = await response.json();
        if (data?.clientPrincipal) {
          setClientPrinciple(data.clientPrincipal);
        } else {
          setClientPrinciple(null);
          localStorage.removeItem("AuthenticatedUser");
        }
      } catch (error) {
        console.error("Error fetching client principle", error);
      }
    };
    fetchClientPrinciple();
  }, []);

  const envInfo = useMemo(() => {
    const env = process.env.REACT_APP_ENVIRONMENT || "dev";

    switch (env) {
      case "sandbox":
        return {
          title: "Development & Demonstration Environment",
          description: "Testing, Training, Demonstration, Synthetic Data",
          warning: `<ul style="text-align:left; padding-left:18px;">
            <li>You are accessing the <b>Development & Demonstration Environment</b>.</li>
            <li>This environment contains only <b>synthetic data</b> and no PII.</li>
            <li>It is intended solely for <b>testing, training, and demonstration</b>.</li>
            <li>Do not enter any genuine or sensitive information.</li>
            <li>By continuing, you acknowledge this is <b>non-production</b>.</li>
          </ul>`,
          confirmButtonColor: "#008584",
        };

      case "dev":
        return {
          title: "Staging Environment",
          description: "Pre-Production Testing with Modified Data",
          warning: `<ul style="text-align:left; padding-left:18px;">
            <li>You are accessing the <b>Staging Environment</b>.</li>
            <li>This may include <b>partial real data</b> and is for QA only.</li>
            <li>Not guaranteed to be accurate or current.</li>
            <li>By continuing, you accept its limitations.</li>
          </ul>`,
          confirmButtonColor: "#4d84c7",
        };

      case "prod":
        return {
          title: "Production Environment",
          description: "Live Disease Investigation and Analysis",
          warning: `<ul style="text-align:left; padding-left:18px;">
            <li>You are accessing the <b>Production Environment</b>.</li>
            <li>This system contains <b>sensitive information</b>.</li>
            <li>Handle all data responsibly and in accordance with policy.</li>
          </ul>`,
          confirmButtonColor: "#3d1413",
        };

      default:
        return {
          title: "Local Environment",
          description: "",
          warning: "<p>Environment not recognized.</p>",
          confirmButtonColor: "#666",
        };
    }
  }, []);

  const handleLoginClick = async () => {
    const result = await MySwal.fire({
      title: `<h2 style="font-size:22px; font-weight:bold; margin:0;">${envInfo.title}</h2>`,
      html: `<p><i>${envInfo.description}</i></p>${envInfo.warning}`,
      icon: "info",
      confirmButtonText: "I Understand",
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonColor: envInfo.confirmButtonColor,
    });

    if (result.isConfirmed) {
      const redirect = window.location.pathname + window.location.search;
      handleLogin(redirect);
    }
  };

  return (
    <Box position="relative" height="100%">
      <HeroSection
        isLoading={isLoading}
        userData={userData}
        clientPrinciple={clientPrinciple}
        handleLoginClick={handleLoginClick}
      />
      <Box>
        <AboutSection />
      </Box>
    </Box>
  );
};

export default Home;
